// countdown.js
(function() {
  function initializeCountdown() {
    var countdownEl = document.getElementById('launch-countdown');
    if (!countdownEl) return;

    var launchDate = new Date(countdownEl.getAttribute('data-launch-date'));
    var timerSpan  = countdownEl.querySelector('#countdown-timer');

    var unitLabels = {
      'D': 'days',
      'H': 'hours',
      'M': 'minutes',
      'S': 'seconds'
    };

    // update every second
    var interval = setInterval(update, 1000);
    update();

    function update() {
      var now  = new Date();
      var diff = launchDate - now;

      if (diff <= 0) {
        clearInterval(interval);
        countdownEl.remove();
        enablePurchase();
        return;
      }

      var days    = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours   = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);

      var parts = [];
      if (days    > 0) parts.push({ v: days,    u: 'D' });
      if (hours   > 0) parts.push({ v: hours,   u: 'H' });
      if (minutes > 0) parts.push({ v: minutes, u: 'M' });
      parts.push({ v: seconds, u: 'S' });

      timerSpan.innerHTML = parts.map(function(p) {
        var vv = p.v.toString().padStart(2, '0');
        return (
          '<span class="countdown-unit">' +
            '<span class="countdown-value">' + vv + '</span>' +
            '<span class="countdown-label">' + unitLabels[p.u] + '</span>' +
          '</span>'
        );
      }).join('');
    }

    function enablePurchase() {
      var form = document.getElementById('purchase-form');
      if (form) form.style.display = 'block';
    }
  }

  document.addEventListener('DOMContentLoaded', initializeCountdown);
})();
